<div class="routine-stats-modal">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-content">
      <mat-icon class="header-icon">insights</mat-icon>
      <div class="header-text">
        <h2 class="modal-title">Routine Statistics</h2>
        <p class="routine-name">{{ data.routineName }}</p>
        <p class="time-range">{{ data.timeRange }}</p>
      </div>
    </div>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="modal-content">
    <!-- Overview Cards -->
    <div class="overview-section">
      <mat-card class="overview-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>analytics</mat-icon>
            Overview
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="overview-stats">
            <div class="stat-item">
              <div class="stat-value">{{ data.stats.totalJobs }}</div>
              <div class="stat-label">Total Jobs</div>
            </div>
            <div class="stat-item">
              <div class="stat-value success">
                {{ data.stats.completedJobs }}
              </div>
              <div class="stat-label">Completed</div>
            </div>
            <div class="stat-item">
              <div class="stat-value error">{{ data.stats.failedJobs }}</div>
              <div class="stat-label">Failed</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ avgDurationMinutes }}m</div>
              <div class="stat-label">Avg Duration</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Success Rate -->
    <div class="success-rate-section">
      <mat-card class="success-rate-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>trending_up</mat-icon>
            Success Rate
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="success-rate-content">
            <div class="rate-display">
              <div class="rate-value">{{ successRate }}%</div>
              <div class="rate-label">Success Rate</div>
            </div>
            <div class="rate-bar">
              <mat-progress-bar
                mode="determinate"
                [value]="successRate"
                color="primary"
              >
              </mat-progress-bar>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Job Status Distribution -->
    <div class="distribution-section">
      <mat-card class="distribution-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>pie_chart</mat-icon>
            Job Status Distribution
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="distribution-content">
            <div class="status-list">
              @for (item of statusDistribution; track item.status) {
                <div class="status-item" [class]="'status-' + item.color">
                  <div class="status-info">
                    <mat-icon [class]="'status-icon-' + item.color">
                      {{ getStatusIcon(item.status) }}
                    </mat-icon>
                    <span class="status-name">{{ item.status }}</span>
                  </div>
                  <div class="status-stats">
                    <span class="status-count">{{ item.count }}</span>
                    <span class="status-percentage"
                      >({{ item.percentage }}%)</span
                    >
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Timeline Information -->
    <div class="timeline-section">
      <mat-card class="timeline-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>schedule</mat-icon>
            Timeline
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="timeline-content">
            <div class="timeline-item">
              <mat-icon class="timeline-icon success">check_circle</mat-icon>
              <div class="timeline-text">
                <div class="timeline-label">Last Successful Run</div>
                <div class="timeline-value">
                  {{ formatDate(data.stats.lastSuccessfulRun) }}
                </div>
              </div>
            </div>
            <div class="timeline-item">
              <mat-icon class="timeline-icon error">error</mat-icon>
              <div class="timeline-text">
                <div class="timeline-label">Last Failed Run</div>
                <div class="timeline-value">
                  {{ formatDate(data.stats.lastFailedRun) }}
                </div>
              </div>
            </div>
            <div class="timeline-item">
              <mat-icon class="timeline-icon primary">event</mat-icon>
              <div class="timeline-text">
                <div class="timeline-label">Next Scheduled Run</div>
                <div class="timeline-value">
                  {{ formatDate(data.stats.nextScheduledRun) }}
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Performance Metrics -->
    <div class="performance-section">
      <mat-card class="performance-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>speed</mat-icon>
            Performance Metrics
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="performance-content">
            <div class="metric-row">
              <div class="metric-label">Average Duration</div>
              <div class="metric-value">
                <span class="metric-number">{{ avgDurationMinutes }}</span>
                <span class="metric-unit">minutes</span>
              </div>
            </div>
            <div class="metric-row">
              <div class="metric-label">Average Duration</div>
              <div class="metric-value">
                <span class="metric-number">{{ avgDurationHours }}</span>
                <span class="metric-unit">hours</span>
              </div>
            </div>
            <div class="metric-row">
              <div class="metric-label">Success Rate</div>
              <div class="metric-value">
                <span class="metric-number success">{{ successRate }}</span>
                <span class="metric-unit">%</span>
              </div>
            </div>
            <div class="metric-row">
              <div class="metric-label">Failure Rate</div>
              <div class="metric-value">
                <span class="metric-number error">{{ failureRate }}</span>
                <span class="metric-unit">%</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Actions -->
  <div class="modal-actions">
    <button mat-button (click)="onClose()">Close</button>
  </div>
</div>
